<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="form.valid" [class.error]="!form.valid">Homeowner</h2>
            </div>
            <div>
                <mat-icon *ngIf="form.valid" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!form.valid" class="header-toggle error">
                    close
                </mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body-container mx-2">
        <form [formGroup]="form">
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Owner Name</mat-label>
                        <input type="text" matInput placeholder="Enter Owner Name"
                            formControlName="property_owner_name">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput placeholder="Enter Property Owner Email"
                            formControlName="property_owner_email">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="d-flex flex-column phone-number-input">
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input type="text" matInput placeholder="Enter Property Owner Phone Number"
                            formControlName="property_owner_phone" (input)="onPhoneNumberChanged($event)">
                        <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Address Line 1</mat-label>
                        <input type="text" matInput placeholder="Address 1" formControlName="address_line_1">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Address Line 2</mat-label>
                        <input type="text" matInput placeholder="Address 2" formControlName="address_line_2">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>City</mat-label>
                        <input type="text" matInput placeholder="City" formControlName="city">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>State/Province</mat-label>
                        <mat-select formControlName="state">
                            <mat-option *ngFor="let state of states" [value]="state.value">{{ state.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Postal Code</mat-label>
                        <input type="text" matInput placeholder="Postal Code" formControlName="postal_code">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Country</mat-label>
                        <mat-select formControlName="country_id">
                            <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.display_text }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</mat-expansion-panel>